import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

const StudentPlacementPage = lazy(() => import('src/pages/student-dashboard-placement'));

// ----------------------------------------------------------------------

// The student's dashboard (#633) is the student view of /dashboard
// (pages/dashboard.js). Here: one of their placements, and the dashboard's
// first address, /my-placement (#603), which emails sent before still link to.
export const studentDashboardRoutes = [
  {
    path: 'dashboard/placements/:id',
    element: (
      <RoleBasedGuard navigateTo roles={[ROLES.USER_ROLE_STUDENT]}>
        <StudentPlacementPage />
      </RoleBasedGuard>
    ),
  },
  { path: 'my-placement', element: <Navigate to={paths.studentDashboard.root} replace /> },
];
